import { instance } from "./api";
const url = process.env.REACT_APP_BASE_URL || "/";

async function getCompanyList(page,limit,filter) {
    // call the api for get company list

    const api = url + `/companies?page=${page}&filter=${encodeURIComponent(filter ?? "")}&limit=${limit}`;
    return await instance
    .get(api)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

export const companyService = {
    getCompanyList
  };